var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgTokenSix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "3.035%",
    x2: "50%",
    y2: "100.436%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675BA5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119AD6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD45B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC659",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0z",
    id: "c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30.669 19.703 2.563 1.18c.14.065.308.054.436-.029.11-.07.172-.18.172-.302v-6.793c0-.465-.298-.892-.778-1.113l-8.35-3.852a1.72 1.72 0 0 0-1.423 0l-8.351 3.852c-.48.221-.778.648-.778 1.113v20.482c0 .465.298.892.778 1.113l8.35 3.852c.223.103.468.154.712.154.244 0 .489-.051.712-.154l8.35-3.852c.48-.221.778-.648.778-1.113v-9.52c0-.465-.298-.891-.778-1.113l-8.35-3.851a1.72 1.72 0 0 0-1.423 0l-3.728 1.72a.368.368 0 0 0-.225.33c0 .14.086.268.225.332l2.86 1.315c.12.056.263.056.383 0l.803-.37a.927.927 0 0 1 .758 0l5.667 2.614c.237.109.383.311.383.528v6.51c0 .217-.146.42-.383.529l-5.667 2.614a.927.927 0 0 1-.758 0l-5.668-2.614c-.236-.11-.383-.312-.383-.529v-7.29l5.733 2.645c.222.103.467.154.711.154.244 0 .489-.051.712-.154l3.728-1.72a.368.368 0 0 0 .224-.33.368.368 0 0 0-.225-.332l-2.86-1.316a.464.464 0 0 0-.383 0l-.803.37a.927.927 0 0 1-.757 0l-5.668-2.613c-.237-.11-.383-.312-.383-.529v-6.357c0-.217.146-.42.383-.529l5.668-2.614a.927.927 0 0 1 .757 0l5.668 2.614c.236.11.383.312.383.529v4.108c0 .14.086.267.225.331",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.88 18.266-5.102 2.268a.184.184 0 0 1-.151 0l-4.963-2.265a.185.185 0 0 0-.261.17v5.498c0 .073.042.139.108.169l5.182 2.367c.05.023.107.022.156-.001l5.185-2.469a.186.186 0 0 0 .106-.167v-5.4a.184.184 0 0 0-.26-.17",
    fill: "url(#f)",
    transform: "translate(14.16 8.64)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTokenSix);
export default __webpack_public_path__ + "static/media/img_token_six.8bae4fdf.svg";
export { ForwardRef as ReactComponent };